import { Filter, PaginatedResponse } from '@libs/models/common';
import { filterToQueryParams } from '../utils/filterToQueryParams';
import { AgencyTypes } from './mocks';
import { AgencyTypeListItem } from '@libs/models/agencies';

type fetchAgenciesListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Filter[];
};
export async function fetchAgencyTypesList(
  params?: fetchAgenciesListParams,
): Promise<PaginatedResponse<AgencyTypeListItem[]>> {
  const filters = filterToQueryParams((params?.filters ?? []).map((fil) => ({ field: fil.key, value: fil.value })));

  // const response = await request.get<PaginatedResponse<AgencyTypesFetchItem[]>>('/facilities', {
  //   params: {
  //     pageNumber: params?.page || 1,
  //     pageSize: params?.size || 50,
  //     search: params?.search || undefined,
  //     ...filters,
  //   },
  // });

  const fake = async () =>
    new Promise<PaginatedResponse<AgencyTypeListItem[]>>((resolve) => {
      setTimeout(() => {
        resolve({
          // ...response.data,
          hasNextPage: false,
          hasPreviousPage: false,
          pageNumber: 1,
          pageSize: AgencyTypes.length,
          totalCount: AgencyTypes.length,
          items: AgencyTypes,
        });
      }, 1000);
    });

  return await fake();
}
